<template>
  <div class="container">
    <div class="content">

      <!-- {{ form }} -->
      <div class="forms">
        <el-form :inline="true" :model="form" ref="form" class="search-form-2" size="small" label-width="84px">
          <el-form-item label="月份选择">
            <el-date-picker v-model="form.month" type="month" placeholder="选择月" @change="getDetail">
            </el-date-picker>
          </el-form-item>
          <el-form-item style="float: right;margin-right: 0;">
            <el-button size="mini" @click="onDownLoad" icon="el-icon-download" :loading="donwloadLoading" v-if="parArray.includes('download_schedule')">下载导入模版</el-button>
            <el-button type="primary" :disabled="isExpirebeMonth" size="mini" @click="showImport" icon="el-icon-upload2" :loading="importLoading"
              v-if="parArray.includes('import_schedule')">导入排班</el-button>
          </el-form-item>
        </el-form>
        <div class="table-head-info">
          <div class="name">排班信息：<span class="text">{{ shiftInfo }}</span></div>
          <div class="name">休息日：<span class="text">固定休息；</span></div>
          <div class="name">节假日：<span class="text">国家法定节假日；</span></div>
          <div class="name">未排班：<span class="text">当天未安排班次</span></div>
        </div>
        <lb-table v-horizontal-scroll="'always'" :column="columns" :data="list" v-loading="loading" marginTop="10px">
        </lb-table>
      </div>
    </div>
    <!-- 导入弹窗 -->
    <pop-import ref="popImport" @onImport="onImport"></pop-import>
  </div>
</template>
<script>
import eldate from "@/components/eldate.vue";
import LbTable from "@/components/lb-table/lb-table";
import popImport from "@/components/popImport.vue";
import { formatDateTime, getWeekDay, isWeekend } from "@/utils/index.js";
export default {
  name: 'attendanceManagementScheduleDetail',
  components: { eldate, LbTable, popImport },
  data() {
    return {

      parArray: [],
      form: {
        month: null

      },
      dayRow: [],
      rowValue: [],
      list: [],
      shiftInfo: '',
      loading: false,
      columns: [
        {
          label: '部门', prop: 'orgName', width: '120', fixed: 'left',
          render: (h, scope) => {
            return (
              <div class='align-left'>{scope.row.orgName}</div>
            )
          }
        },
        {
          label: '工号', prop: 'employeeNo', width: '120', fixed: 'left',
          render: (h, scope) => {
            return (
              <div class='align-left'>{scope.row.employeeNo}</div>
            )
          }
        },
        {
          label: '姓名', prop: 'name', minWidth: '120', fixed: 'left',
          render: (h, scope) => {
            return (
              <div class='align-left'>{scope.row.name}</div>
            )
          }
        }
      ],
      donwloadLoading: false,
      importLoading: false,
      nowDate: null,
    }
  },
  activated() {
    this.id = this.$route.query.id
    // 设置默认月份为当前 Date 对象
    this.nowDate = new Date()
    this.$nextTick(() => {
      this.form.month = this.nowDate
      this.getDetail();
    })
  },
  computed: {
    isExpirebeMonth() {
      const selectedMonth = new Date(this.form.month)
      const currentMonth = new Date(this.nowDate)

      if (isNaN(selectedMonth.getTime()) || isNaN(currentMonth.getTime())) {
        return false
      }

      return selectedMonth.getFullYear() < currentMonth.getFullYear() ||
        (selectedMonth.getFullYear() === currentMonth.getFullYear() &&
          selectedMonth.getMonth() < currentMonth.getMonth())
    }
  },
  created() {
    // 权限设定判断 
    const limits = JSON.parse(sessionStorage.getItem("limit"))
    const params = limits.buttonTreeDto.find(
      (item) => item.menuCode === "attendanceManagementSchedule"
    )
    params && params.buttonList.forEach((item) => {
      this.parArray.push(item.code)
    })
  },
  methods: {
    getDetail() {
      const postDate = {
        month: formatDateTime(this.form.month, 'yyyy-mm'),
        id: this.id
      }
      this.list = []
      this.dayRow = []
      this.rowValue = []
      this.loading = true
      this.$api.scheduleDetail(postDate).then((res) => {
        if (res.code === 0) {
          this.list = res.data && res.data.members || []
          this.dayRow = res.data && res.data.days || []
          this.rowValue = res.data && res.data.cells || []
          const shifts = res.data && res.data.shifts || []
          let shiftInfo = ''
          shifts.forEach(item => {
            shiftInfo += `${item.name}  ${item.timeRange}；`
          })
          this.shiftInfo = shiftInfo
          this.initDayValue()
        }
      }).finally(() => {
        this.$nextTick(() => {
          setTimeout(() => {
            this.loading = false
          }, 800)
        })
      })
    },
    onDetail(val) {
      this.$router.push({ name: 'attendanceManagementScheduleDetail', query: { id: val.id } })
    },
    onDownLoad() {
      this.donwloadLoading = true
      const postDate = {
        month: formatDateTime(this.form.month, 'yyyy-mm'),
        id: this.id
      }
      this.$api.scheduleDownload(postDate).then(res => {
        if (res.code === 0) {
          const data = res.data || {}
          this.downloadlink(data.fileUrl)
        }
      }).finally(() => {
        this.donwloadLoading = false
      })
    },
    showImport() {
      const data = {
        title: '导入排班',
        info: '大小限制在4M以内，格式仅支持模版格式',
        maxSize: 4,
        accept: '.xls,.xlsx'
      }
      this.$refs.popImport.show(data)
    },
    onImport(formData) {
      this.importLoading = true
      const postDate = {
        month: formatDateTime(this.form.month, 'yyyy-mm'),
        id: this.id,
        file: formData
      }
      this.$api.scheduleImport(postDate).then(res => {
        if (res.code === 0 && res.data.message) {
          const message = res.data.message
          if (message === '导入成功') {
            this.$message({ message: message, type: 'success' })
          } else {
            this.$message({ message: message, type: 'error', duration: 5000 })
          }
          this.getDetail()
        }
        this.$refs.popImport.close()
      }).finally(() => {
        this.importLoading = false
      })
      console.log('onImport:', formData)
    },
    scheduleCellText(value) {
      if (!value) return '未排班'
      if (value.scheduleType === 'SHIFT') return value.shiftName || '未排班'
      const scheduleTypeText = {
        NONE: '休息日',
        HOLIDAY: '节假日',
        EMPTY: '未排班'
      }
      // 旧接口没有scheduleType时仍兼容展示已有班次名称。
      return scheduleTypeText[value.scheduleType] || value.shiftName || '未排班'
    },
    initDayValue() {
      // 根据 dayRow 动态追加列（不能在 data() 中写循环语句）
      this.columns = this.columns.slice(0, 3)
      for (let i = 0; i < this.dayRow.length; i++) {
        const idx = i
        this.columns.push({
          label: this.dayRow[i].name,
          prop: 'rowValue',
          width: '100',
          renderHeader: (h, scope) => {
            const day = this.dayRow[idx]
            const week = day && getWeekDay(day)
            const weekend = isWeekend(day)
            return (
              <div class={weekend ? 'day-week day-week-hot' : 'day-week'}>
                <span class='day'>{day}</span>
                <span class='week'>{week}</span>
              </div>
            )
          },
          render: (h, scope) => {
            // let value = this.rowValue[idx] || {}
            const day = this.dayRow[idx]
            const userId = scope.row.userId
            const value = this.rowValue.find(item => item.date === day && item.userId === userId)
            const text = this.scheduleCellText(value)
            return <div class='align-center ellipsis' title={text}>{text}</div>
          }
        })
      }
    }

  }

}
</script>
<style lang="scss">
.day-week {
  line-height: 1;
  text-align: center;

  .day {
    display: inline-block;
    font-size: 12px;
    margin-bottom: 4px;
  }

  .week {
    display: inline-block;
    font-size: 13px;
  }
}

.day-week-hot {

  .day,
  .week {
    color: #E23C58;
  }
}
</style>
<style lang="scss" scoped>
.table-head-info {
  display: flex;
  font-size: 13px;

  .name {
    color: #333;
    padding-right: 20px;
  }

  .text {
    color: #666;
  }
}
</style>
<style lang="scss" src="@/pages/attendanceManagement/common/style/common.scss" scoped />
